import React from "react"
import CustomTable from "../../components/CustomTable";
import { addReligionName, editReligionName, getAllReigions, religionsUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import { AddButton } from "../../components/masterDataForm/AddButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddMasterDataWithCountryCode from "../../components/masterDataForm/AddMasterDataWithCountryCode";
import EditMasterFormWithCountryCode from "../../components/masterDataForm/EditMasterFormWithCountryCode";

const Religion = () => {
    const dispatch = useDispatch();
    const religionsInfo = useSelector(state => state?.getAllReligions?.religions)
    const [showReligion, setReligionShow] = React.useState(false);
    const [showAddReligion, setAddReligionShow] = React.useState(false);
    const [reigionsValName, setReigionsValName] = React.useState();

    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllReigions();
                dispatch({ type: 'GET_ALL_RELIGIONS', payload: res.data.data})
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const editReligionsHandle = async (religions) => {
        try {
            const religionsPayload = {
                religionId: religions?.statusId,
                name: religions?.name,
                isoCode: religions?.isoCode
            }
            const editReligionsNames = await editReligionName(religionsPayload);
            if(editReligionsNames.status === 200) {
                dispatch({ type: 'UPDATE_RELIGIONS_NAME', payload: editReligionsNames.data?.data})
                toast.success(editReligionsNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };
    const addReligionHandle = async (religionName) => {
        try {
            const addReligionNames = await addReligionName(religionName);
            if(addReligionNames.status === 200) {
                dispatch({ type: 'ADD_RELIGIONS_NAME', payload: addReligionNames.data?.data})
                toast.success(addReligionNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const religionsApprovedAndUnAprooved = async (religionsId) => {
        try {
            const approvedAndUnapprovedStatus = await religionsUpdateApprovedAndUnapproved(religionsId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_RELIGIONS_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={religionsApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data._id} isoCode={val.data?.isoCode} hadnleEditName={setReigionsValName} handleEditBtn={setReligionShow}/>) }
        ];
    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Religion</h3>
            </div>
            <AddButton formName="Religion" handleAddBtn={setAddReligionShow} />
            <CustomTable colDefs={colDefs} rowData={religionsInfo} />
            <AddMasterDataWithCountryCode formName="Religion" addMasterData={addReligionHandle} showAddForm={showAddReligion} setShowAddForm={setAddReligionShow} />
            <EditMasterFormWithCountryCode formName="Religion" editMasterDataName={reigionsValName} editMasterData={editReligionsHandle} showEditForm={showReligion} setShowEditForm={setReligionShow}/>
        </React.Fragment>
    )
};
export default Religion;